// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"usergroup-circle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11 16.5C11 15.3954 11.8954 15 13 15H15C16.1046 15 17 15.3954 17 16.5M6.5 16.0002V15.5545C6.5 13.5002 8.09331 13.0002 9 13.0002M9 9.73244C8.35897 9.36217 8 8.74028 8 8C8 6.89543 8.89543 6 10 6C10.1727 6 10.3402 6.02188 10.5 6.06301M12 10C12 11.1046 12.8954 12 14 12C15.1046 12 16 11.1046 16 10C16 8.89543 15.1046 8 14 8C12.8954 8 12 8.89543 12 10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UsergroupCircleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'usergroup-circle',
    ref,
    icon: element,
  },
));

UsergroupCircleIcon.displayName = 'UsergroupCircleIcon';

export default UsergroupCircleIcon;
